import * as dataStore from './data-store.js';
import * as dateUtils from './date-utils.js';

const googleDocIdLeaderboardGP2023 =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vRbNcBwX9b95wx21s-8M3Abls5zPBj3WHvOFaak7jofx431ayebgdMHVv8c2Rr-ZOqtqjZHjCFrd31W/pub?gid=0&single=true&output=csv';

const googleDocIdLeaderboardGP2024 = 
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vTAjZkRTQiaKHKWxBpDdNWH7eL_dhHa9ApaiuOprWUXEG3vcrIr6xgKmbwUWQ_4FV24taJDO7XTR-K2/pub?gid=0&single=true&output=csv';

const googleDocIdLeaderboardGP2025 = 
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vT-spkDqeKdWvyk9_TEvDPy3IDglNBxM9i008Vy4_CZgHwzuOyG7N22uW_P7m66gHQPjwI8T9PCTrUp/pub?gid=0&single=true&output=csv';

const startYear = 2023;

const googleDocId2023GP = '2PACX-1vRbNcBwX9b95wx21s-8M3Abls5zPBj3WHvOFaak7jofx431ayebgdMHVv8c2Rr-ZOqtqjZHjCFrd31W';
const googleDocId2024GP = '2PACX-1vTAjZkRTQiaKHKWxBpDdNWH7eL_dhHa9ApaiuOprWUXEG3vcrIr6xgKmbwUWQ_4FV24taJDO7XTR-K2';
const googleDocId2025GP = '2PACX-1vT-spkDqeKdWvyk9_TEvDPy3IDglNBxM9i008Vy4_CZgHwzuOyG7N22uW_P7m66gHQPjwI8T9PCTrUp';
const googleDocId2026GP = '2PACX-1vT70KtM77jxLy-YaHrtrlVDAD7UUXkZZN26OwFAqy1mxjGvpTu97KEsQkkmHyFAXmRs42-FCOEEsH8N';
const googleDocIdsGP = [googleDocId2023GP, googleDocId2024GP, googleDocId2025GP, googleDocId2026GP];

const googleMonthsTabsIdsGP = ['2050273654', '894964860', '1029443492', '1265733486', '637691318', '671778284','14808792','1818273324', '743798872','111029067','137950792','1778547717'];
const leaderboardTabIdGP = '0';
const predictionsTabIdGP = '1463435365';

let appCallback = null;

export function setCallback(cb) {
  appCallback = cb;
}

export function getCallback() {
  return appCallback;
}

function getGoogleDocIdGP(year) {
  const yearDiff = year - startYear;
  return googleDocIdsGP[yearDiff];
}

function getGoogleDocIdLeaderboardGP(year) {
  const yearDiff = year - startYear;
  const url = `https://docs.google.com/spreadsheets/d/e/${googleDocIdsGP[yearDiff]}/pub?gid=${leaderboardTabIdGP}&single=true&output=csv`;
  return url
}

function formatPredictedTime(timeString) {
  if (!timeString || timeString === '') return '';
  
  // Parse hh:mm:ss format
  const parts = timeString.split(':');
  if (parts.length !== 3) return timeString;
  
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parseInt(parts[2], 10);
  
  // Convert to total minutes and seconds
  const totalMinutes = hours * 60 + minutes;
  
  // Format as mm:ss
  return `${totalMinutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

export async function showLeaderboard(year, screenWidth) {
  let maxCol = 0;
  let tableResults = document.getElementById('table-leaderboard');
  tableResults.innerHTML = '';
  let showLeaderboardColumns = [
    0, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 33
  ];
  if (year == 2023) {
    showLeaderboardColumns = [
      0, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 32
    ];
  
  }
  const monthColumns = [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27];
  const totalColumn = 25;
  // console.log('Showing Leaderboard with width:', screenWidth);
  if (screenWidth < 600) {
    showLeaderboardColumns = [0, 15, 29, 30];
  }
  await dataStore.loadData(getGoogleDocIdLeaderboardGP(year)).then((data1) => {
    // console.log(data1);
    data1.forEach((row, rowIndex) => {
      let tr = tableResults.insertRow();
      // console.log(row);
      row.forEach((col, colIndex) => {
        // Only show people with points
        if (row[30] > 0 || rowIndex == 0) {
          // Add position column
          if (colIndex == 0) {
            if (rowIndex == 0) {
              tr.appendChild(document.createElement('th'));
            } else {
              tr.insertCell().innerHTML = rowIndex;
            }
          }
          if (rowIndex > 0 && monthColumns.includes(colIndex)) {
            // console.log(rowIndex, colIndex, col);
            if (col !== '' && colIndex > maxCol) {
              maxCol = colIndex;
            }
          }
          if (showLeaderboardColumns.includes(colIndex)) {
            if (rowIndex == 0) {
              let th = document.createElement('th');
              const monthNo = monthColumns.indexOf(colIndex);
              if (monthNo > -1) {
                th.className = 'month-result';
                col = col.substr(0, 3);
                th.innerHTML = `<span><abbr>${col}</abbr></span>`;
                th.onclick = () => {
                  this.getCallback().onMonthSelect(monthNo + 1);
                };
              } else {
                th.innerHTML = col;
              }
              tr.appendChild(th);
            } else {
              let td = tr.insertCell();
              if (colIndex == totalColumn) {
                td.className = 'total-points';
              }
              if (monthColumns.includes(colIndex)) {
                // td.className = 'month-result';
                if (row[colIndex - 15] == '1') {
                  td.className = ' gold-card';
                }
              }
              td.innerHTML = col;
              // Gold Card
              if (year == 2023 && colIndex == 32 || year >= 2023 && colIndex == 33) {
                const goldCardCount = col;
                if (goldCardCount == 2) {
                  td.innerHTML =
                    '<i class="fa fa-xl fa-ticket"></i><i class="fa fa-xl fa-ticket"></i>';
                } else if (goldCardCount == 1) {
                  td.innerHTML = '<i class="fa fa-xl fa-ticket"></i>';
                } else {
                  td.innerHTML = '';
                }
              }
            }
          }
        }
      });
    });
  });
  return monthColumns.indexOf(maxCol) + 1;
}

export async function showMonth(year, monthNo, screenWidth) {
  document.getElementById('month-name').innerText = dateUtils.longmonth(monthNo);
  let showColumns = [0, 2, 4, 6, 7, 8];
  let table2 = document.getElementById('table-month');
  table2.innerHTML = '';
  document.getElementById('race-name').innerHTML = '';
  if (screenWidth < 600) {
    showColumns = [0, 2, 6, 7];
  }
  const docId = dataStore.googleTabUrl(
    googleMonthsTabsIdsGP,
    getGoogleDocIdGP(year),
    monthNo
  );
  // console.log(showColumns);
  await dataStore.loadData(docId).then((data1) => {
    // console.log(data1);
    let headerDetails = data1[0];
    let raceName = headerDetails[0];
    let raceDistance = headerDetails[6];
    let raceDifficulty = headerDetails[7]
    // raceName = raceName.substr(0,raceName.indexOf(','))
    document.getElementById('month-name').innerText = `${dateUtils.longmonth(monthNo)}`;
    document.getElementById('race-name').innerHTML = `<span>${raceName}</span><span class="sep">&bull;</span><span>${raceDistance}</span><span class="sep">&bull;</span><span>${raceDifficulty}</span>`;
    data1.forEach((row, rowIndex) => {
      let tr = table2.insertRow();
      // console.log(row);
      row.forEach((col, colIndex) => {
        if (rowIndex > 0) {
          // Add position column
          // if (colIndex == 0) {
          //   if (rowIndex == 1) {
          //     tr.appendChild(document.createElement('th'));
          //   } else {
          //     tr.insertCell().innerHTML = rowIndex - 1;
          //   }
          // }
          if (showColumns.includes(colIndex)) {
            if (rowIndex == 1) {
              let th = document.createElement('th');
              th.innerHTML = col;
              tr.appendChild(th);
            } else {
              let td = tr.insertCell();
              td.innerHTML = col;
              if (colIndex == 6 && col !== null) {
                const diffPercentage = parseFloat(col);
                if (diffPercentage < -1) {
                  td.className = 'time-neg';
                } else if (diffPercentage > 1) {
                  td.className = 'time-pos';
                } else {
                  td.className = 'time-equal';
                }
              }
              if (colIndex == 8 && col !== '') {
                td.innerHTML = '<i class="fa fa-xl fa-ticket"></i>';
              }
            }
          }
        }
      });
    });
  });
  return true;
  //}
}

export async function showPredictions(screenWidth) {
  let table = document.getElementById('table-predictions');
  table.innerHTML = '';
  
  let showColumns = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
  if (screenWidth < 600) {
    showColumns = [0, 1, 2, 7, 12];
  }
  
  const url = `https://docs.google.com/spreadsheets/d/e/${getGoogleDocIdGP(2026)}/pub?gid=${predictionsTabIdGP}&single=true&output=csv`;
  
  await dataStore.loadData(url).then((data) => {
    // Extract event info from B3 to B6 (rows 2-5, column 1)
    let raceName = data[2] ? data[0][1] : '';
    let raceDate = data[3] ? data[1][1] : '';
    let raceDistance = data[4] ? data[2][1] : '';
    let raceGrading = data[5] ? data[3][1] : '';
    
    // Display event info
    document.getElementById('predictions-name').innerHTML = 
      `<span>${raceName}</span><span class="sep">&bull;</span><span>${raceDate}</span><span class="sep">&bull;</span><span>${raceDistance}km</span><span class="sep">&bull;</span><span>Grading ${raceGrading}</span>`;
    
    // Add header row
    let headerRow = table.insertRow();
    for (let colIndex = 0; colIndex < 14; colIndex++) {
      if (showColumns.includes(colIndex)) {
        let th = document.createElement('th');
        if (colIndex == 0) {
          th.innerHTML = 'Member';
        } else if (colIndex == 1) {
          th.innerHTML = 'Predicted';
        } else if (colIndex >= 2 && colIndex <= 12) {
          if (colIndex == 7) {
            th.innerHTML = 'Target';
          } else {
          const percentageOffset = ((colIndex - 2) - 5) * 1;
          th.innerHTML = `${percentageOffset > 0 ? '+' : ''}${percentageOffset}${percentageOffset !== 0 ? '%' : ''}`;
          }
        }
        headerRow.appendChild(th);
      }
    }
    
    // Add data rows starting from row 6 (index 5)
    for (let rowIndex = 5; rowIndex < data.length; rowIndex++) {
      const row = data[rowIndex];
      let tr = table.insertRow();
      row.forEach((col, colIndex) => {
        if (showColumns.includes(colIndex)) {
          let td = tr.insertCell();
          // Format predicted time column (column 1) from hh:mm:ss to mm:ss
          if (colIndex > 0) {
            td.innerHTML = formatPredictedTime(col);
          } else {
            td.innerHTML = col;
          }
          // Add styling classes for percentage columns
          if (colIndex >= 2 && colIndex <= 12) {
            if (colIndex < 7) {
              td.className = 'time-neg';
            } else if (colIndex === 7) {
              td.className = 'time-equal';
            } else {
              td.className = 'time-pos';
            }
          }
        }
      });
    }
  });
  return true;
}
